export const CookieManager = (() => {
    const setCookie = (name, value, days = 30) => {
        const expires = new Date(Date.now() + days * 864e5).toUTCString();
        document.cookie = `${name}=${encodeURIComponent(value)}; path=/; expires=${expires}`;
    };

    const getCookie = (name) => {
        return document.cookie.split('; ').reduce((r, v) => {
            const parts = v.split('=');
            return parts[0] === name ? decodeURIComponent(parts[1]) : r;
        }, null);
    };

    const deleteCookie = (name) => {
        document.cookie = `${name}=; Max-Age=-1; path=/`;
    };

    return {
        set: setCookie,
        get: getCookie,
        remove: deleteCookie,
    };
})();
